export function calculateDynamicTimeout(
  fileSizeInBytes: number,
  operationType: 'normal' | 'extended' = 'normal',
): number {
  const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

  if (operationType === 'normal') {
    const baseTimeoutInSeconds = 10;
    const timeoutPerMB = 8;
    const calculatedTimeout = baseTimeoutInSeconds + fileSizeInMB * timeoutPerMB;
    return Math.min(Math.max(calculatedTimeout, 60), 300); // Between 1-5 minutes
  } else {
    const baseTimeoutInSeconds = 30;
    const timeoutPerMB = 25; // Significantly higher multiplier
    const calculatedTimeout = baseTimeoutInSeconds + fileSizeInMB * timeoutPerMB;
    return Math.min(Math.max(calculatedTimeout, 180), 1800); // Between 3-30 minutes
  }
}
